import { Button, Tooltip } from 'antd';
import { Calendar } from '../../utils/icons';
import { useTranslation } from 'react-i18next';
import useApi from '../../utils/api';
import { changeDateInApi } from '../../utils/actions';
import { notificationMessage } from '../../utils/hooks';
import { useState } from 'react';

const ChangeDate = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const { t } = useTranslation();
  const { api } = useApi();
  const onChangeDate = () => {
    setLoading(true);
    api(changeDateInApi())
      .then((resp) => {
        notificationMessage({
          message: t('changeDate.newDate', { newDate: resp.data.nextDate }),
          type: 'success',
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      {process.env.REACT_APP_CAN_CHANGE_DATE && (
        <Tooltip placement="topRight" title={t('changeDate.title')}>
          <Button
            loading={loading}
            onClick={onChangeDate}
            className="primary absolute bottom-[16px] left-[16px] min-w-[40px] px-[8px]"
          >
            {!loading && <Calendar />}
          </Button>
        </Tooltip>
      )}
    </>
  );
};

export default ChangeDate;
